<script setup async>
import {onMounted, ref} from 'vue'
import JwtService, {getExpireToken} from '@/common/jwt.service'
import {useStore} from 'vuex'
import {AUTH_LOGOUT} from '@/common/config'
import {Budget} from '@/common/api.service'
import {LOGOUT, REFRESH_TOKEN} from '@/store/actions.type'
import moment from 'moment'

const user = ref({})
const store = useStore()
const showRole = ref(false)
const changeRoleModel = ref(false)

async function logout() {
  await store
      .dispatch(LOGOUT)
      .then(() => {
        window.location.href = AUTH_LOGOUT + '?post_logout_redirect_uri=' + encodeURIComponent(document.location.origin) + '/'
      })
}

function showRoleShift(r) {
  showRole.value = r
  changeRoleModel.value = user.value.active_role.id
}

const showHeaderUserNav = ref(false)
/*
function hideHeaderUserNav() {
  showHeaderUserNav.value = false
}

 */

async function changeRole() {
  Budget.accountSetActiveRole(changeRoleModel.value).then(async () => {
        window.location.reload();
      });
}

async function activity() {
  let date = new Date()
  if (
      JwtService.getLastAction() <
      moment(date)
          .add(-180, 'm')
          .toDate()
          .getTime()
  ) {
    //alert('Будет осуществлен выход из системы по причине не активности!')
    clearInterval(act)
    //await logout()
  }
}

async function upToken() {
  if (getExpireToken() > 0 && moment().isAfter(moment.unix(getExpireToken()))) {
    await store.dispatch(REFRESH_TOKEN).then(async () => {}).catch(async () => {
      await logout()
    })
  }
}

if (JwtService.getToken()) {
  await Budget.account().then(({data}) => {
    user.value = data.user
  }).catch(async () => {
    await logout()
    //username.value = jwtDecode(JwtService.getToken())['username']
  })

  setInterval(upToken, 1000)
}
const act = setInterval(activity, 1000)

onMounted(() => {
  JwtService.saveLastAction(new Date().getTime())
})

</script>
<template>
  <header class="header">
    <div class="container">
      <div class="header__wrapper">
        <ul class="main-menu --estimate-style">
          <li class="menu-item current">
            <a href="#">Смета проекта</a>
          </li>
          <li class="menu-item">
            <a href="#">Иные модули</a>
          </li>
        </ul>
        <div class="header__right-box --estimate-style">
          <div class="user-profile user-profile--js">
            <div class="user-profile__user user-profile__user--js">
              <span class="user-profile__user-name" @click="showHeaderUserNav=true">{{user.active_role.description}}</span>
              <span class="user-profile__chevron-icon user-profile__chevron-icon--js"></span>
            </div>
            <div class="user-profile__window user-profile__window--js" :class="{'active': showHeaderUserNav}">
              <div class="user-profile__window-top user-profile__link--js">
                <a href="#" @click="showRoleShift(true)">Профиль пользователя</a>
              </div>
              <div class="user-profile__window-bottom user-profile__link--js">
                <a href="#" @click="logout()">Выйти</a>
              </div>
            </div>
          </div>
          <a class="header__help-icon" href="#"></a>
        </div>
      </div>
    </div>
  </header>
  <div class="modal-overlay --estimate-style active"  v-if="showRole">
    <div class="popup">
      <div class="modal-title">Изменить роль</div>
      <div class="modal-body">
        <form action="#">
          <div class="df-fc modal-grid-row">
            <label for="">Укажите роль
            <select v-model="changeRoleModel" class="c-input c-select">
              <option :key="g.id"
                      v-for="g in user.list_all_roles"
                      :value="g.id">
                {{ g.description }}
              </option>
            </select>
            </label>
          </div>
        </form>
      </div>
      <div class="modal-bottom">
        <div class="buttons-block">
          <button class="button --send" @click="showRoleShift(false)">отменить</button>
          <button class="button" @click="changeRole()">изменить</button>
        </div>
      </div>
    </div>
  </div>
</template>